@if ({
  invoiceAvis: invoiceAvis$ | async,
  errorAvis: errorAvis$ | async
  }; as type) {
  @if (invoiceAvis) {
    <div class="row">
      <div class="col-md-3 title">
        <p>{{ 'customUserPayments.avis.number' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceAvis.avisNumber }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 title">
        <p>{{ 'customUserPayments.avis.date' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceAvis.formattedAvisDate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 title">
        <p>{{ 'customUserPayments.avis.balance' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceAvis.balancePriceData.formattedValue }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 title">
        <p>{{ 'customUserPayments.avis.cashDiscount' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceAvis.cashDiscountAmountPriceData.formattedValue }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 title">
        <p>{{ 'customUserPayments.avis.plannedAmount' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceAvis.plannedAmountPriceData.formattedValue }}</p>
      </div>
    </div>
  }
  <div class="form-group row">
    <div class="col-md-5">
      <button
        class="btn btn-secondary btn-block mb-3"
        type="button"
        (click)="goToUserPayments()"
        >
        {{ 'customUserPayments.buttons.back' | cxTranslate }}
      </button>
    </div>
  </div>
  @if (invoiceAvis || errorAvis) {
    <!-- TABLE -->
    <table class="table user-payments-avis-table">
      <thead class="user-payments-avis-thead-mobile">
        <th scope="col" class="warehouse">
          {{ 'customUserPayments.avis.warehouse' | cxTranslate }}
        </th>
        <th scope="col" class="accDocumentNumber">
          {{ 'customUserPayments.avis.accDocumentNumber' | cxTranslate }}
        </th>
        <th scope="col" class="billingDate">
          {{ 'customUserPayments.avis.billingDate' | cxTranslate }}
        </th>
        <th scope="col" class="amount">
          {{ 'customUserPayments.avis.amount' | cxTranslate }}
        </th>
        <th scope="col" class="cashDiscount">
          {{ 'customUserPayments.avis.cashDiscountTitle' | cxTranslate }}
        </th>
        <th scope="col" class="plannedAmount">
          {{ 'customUserPayments.avis.plannedAmountTitle' | cxTranslate }}
        </th>
      </thead>
      <tbody>
        @if (entries && entries.length === 0) {
          <tr>
            <td class="emptyTable" colspan="13">
              {{  'customUserPayments.emptyTable' | cxTranslate }}
            </td>
          </tr>
        }
        @for (entry of entries; track entry) {
          <tr>
            <!--Warehouse-->
            <td class="warehouse">
              <div class="col-6 d-md-none user-payments-avis-label">
                {{ 'customUserPayments.avis.warehouse' | cxTranslate }}
              </div>
              <div class="user-payments-avis-value">
                {{ entry?.warehouse }}
              </div>
            </td>
            <!--Account document number-->
            <td class="accDocumentNumber">
              <div class="col-6 d-md-none user-payments-avis-label">
                {{ 'customUserPayments.avis.accDocumentNumber' | cxTranslate }}
              </div>
              <div class="user-payments-avis-value">
                <a
                  [routerLink]="
                  {
                    cxRoute: 'userPaymentsDetails',
                    params: {
                       invoiceNumber: entry?.accountingDocumentNumber,
                       companyCode: entry?.companyCode,
                       bookingYear: entry?.fiscalYear,
                       bookingTime: entry?.numberOfLine
                     }
                  } | cxUrl
                  "
                class="user-payments-avis-value">
                {{ entry?.accountingDocumentNumber }}
              </a>
            </div>
          </td>
          <!--Billing Date-->
          <td class="billingDate">
            <div class="col-6 d-md-none user-payments-avis-label">
              {{ 'customUserPayments.avis.billingDate' | cxTranslate }}
            </div>
            <div class="user-payments-avis-value">
              {{ entry?.formattedBillingDate }}
            </div>
          </td>
          <!--Amount -->
          <td class="amount">
            <div class="col-6 d-md-none user-payments-avis-label">
              {{ 'customUserPayments.avis.amount' | cxTranslate }}
            </div>
            <div class="user-payments-avis-value">
              {{ entry?.amountPriceData.formattedValue }}
            </div>
          </td>
          <!--Cash Discount-->
          <td class="cashDiscount">
            <div class="col-6 d-md-none user-payments-avis-label">
              {{ 'customUserPayments.avis.cashDiscountTitle' | cxTranslate }}
            </div>
            <div class="user-payments-avis-value">
              {{ entry?.cashDiscountAmountPriceData.formattedValue }}
            </div>
          </td>
          <!--Planned Amount-->
          <td class="plannedAmount">
            <div class="col-6 d-md-none user-payments-avis-label">
              {{ 'customUserPayments.avis.plannedAmountTitle' | cxTranslate }}
            </div>
            <div class="user-payments-avis-value">
              {{ entry?.plannedAmountPriceData.formattedValue }}
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <cx-spinner></cx-spinner>
}
}